<template>
  <div id="compras-bloqueadas" style="margin-top: 10px" class="w3-container">
    <div class="w3-row-padding row-compras-bloqueadas">
    
      <div v-cloak class="w3-panel w3-theme w3-card" v-if="processando">
        <p><i class="fa fa-sync-alt w3-spin"></i> Processando...</p>
      </div>
      
      <div v-if="!processando" class="w3-margin-bottom">
        <input
          class="w3-input w3-border w3-padding margin-bottom-filtro"
          type="text"
          placeholder="Pesquise por nome ou código"
          v-model="filtro"
          v-on:keyup="filtrarPedidos()">
      </div>

      <div
        class="w3-panel w3-text-theme w3-bottombar w3-border-theme w3-border w3-animate-left"
        v-if="!processando && ((!compras_filtradas) || (compras_filtradas.length == 0))"
        v-cloak>

        <div class="w3-container w3-white">
          <p>Não há pedidos de compra a serem exibidos.</p>
        </div>
      </div>

      <div class="wrapper-componente">
        
        <div  
          class="card-item w3-container "
          v-for="(compra, compra_index) in novasComprasBloqueadasFiltradas"
          :key="compra_index"
          v-cloak
        >
        
          <div class="w3-col s12">
            <legenda>
              <strong>Código e valor da compra</strong>
              <i slot="referencia" class="fas fa-shopping-basket w3-text-theme"></i>&nbsp;
            </legenda>
            <strong class="w3-text-theme">{{compra.compra_id}}</strong>
            <strong style="color:green; margin-left: calc(100% - 170px);">R$ {{compra.valor_pedido}}</strong>
          </div>
            
          <div class="w3-col s12">
            <strong class="w3-left">
              <legenda>
                <strong>Fornecedor</strong>
                <i slot="referencia" class="far fa-handshake w3-text-theme"></i>&nbsp;
              </legenda>
              <strong>{{compra.nome_fornecedor}}</strong>
            </strong>
          </div>
            
          <div class="w3-col s12">
            <strong class="w3-left">
              <legenda>
                <span>Data compra</span>
                <i slot="referencia" class="far fa-calendar-alt w3-text-theme"></i>&nbsp;
              </legenda>
              <label>{{compra.data_cadastro}}</label>
            </strong>
          </div>

          <div class="w3-third" v-if="compra.recusado != 'Não'">
            <strong class="w3-text-red">Recusado </strong>
          </div>

          <div class="w3-third">
            <label>Comprador: </label><strong>{{compra.comprador_id}} - {{compra.nome_comprador}}</strong>
          </div>

          <div class="w3-col s12">
            <strong class="w3-left">
              <legenda>
                <span>Empresa</span>
                <i slot="referencia" class="fas fa-building  w3-text-theme"></i>&nbsp;
              </legenda>
              <label>{{compra.empresa_id}} - {{compra.nome_empresa}}</label>
            </strong>
          </div>
            
          <div class="w3-row">
            <div class="w3-center" style="margin-top: 10px;">
              <button
                class="btn-liberar w3-button w3-green"
                @click.prevent="liberarCompra(compra.compra_id)"
                style="width: 270px; margin-bottom: 5px">
                <i class="fas fa-check"></i>
                Liberar
              </button>

              <button
                class="btn-voltar-orcamento w3-button w3-theme"
                @click.prevent="recusarCompra(compra.compra_id)"
                style="width: 270px; margin-bottom: 5px;">
                <i class="far fa-hand-paper"></i>
                Recusar
              </button>

              <button
                class="btn-liberar w3-button w3-blue"
                style="margin-bottom: 5px"
                @click.stop="mostrarDetalhes(compra.compra_id)">
                <strong v-if="!compra.mostrar_detalhes"><i class="fas fa-search-plus"></i></strong>
                <strong v-if="compra.mostrar_detalhes"><i class="fas fa-search-minus"></i></strong>
                &nbsp;
                Detalhes
              </button>
            </div>

            <div 
              v-if="(
                (compra.mostrar_detalhes) &&
                (compra.ocorrencias) && 
                (compra.ocorrencias.length > 0)
              )">

              <div style="border-bottom: 2px dotted #a3a3a3;" class="w3-col"></div>
              <h6>
                &nbsp;
                <i class="fas fa-info-circle"/>&nbsp;
                <strong style="color: #333333;"> Bloqueios </strong> 
              </h6>
              <div style="border-bottom: 2px dotted #a3a3a3;" class="w3-col"></div>
              <div style="margin-bottom:10px;" />
          
              <div 
                style="margin-top: 20px" 
                class="card-item w3-container w3-white"
                v-for="(ocorrencia, ocorrencia_index) in compra.ocorrencias" 
                :key="ocorrencia_index">

                <div class="w3-col s12">
                  <label>Ocorrência: </label>
                  <strong>{{ocorrencia.ocorrencia_id}}</strong>
                </div>

                <div class="w3-col s12">
                  <label>Data: </label>
                  <strong>{{ocorrencia.data_ocorrencia}}</strong>
                </div>

                <div class="w3-col s12">
                  <label>Usuário: </label>
                  <strong>{{ocorrencia.nome_usuario_cadastro}}</strong>
                </div>

                <div class="w3-col s12">
                  <label>Tipo: </label>
                  <strong class="w3-text-theme">{{ocorrencia.nome_tipo_ocorrencia}}</strong>
                </div>  

                <div class="w3-col s12">
                  <label>Hora do cadastro: </label>
                  <strong>{{ocorrencia.hora_cadastro}}</strong>
                </div>

                <div class="w3-col s12">
                  <label>Descrição do bloqueio: </label>
                  <label style="text-decoration: underline;">{{ocorrencia.observacao}}</label>
                </div>

                <hr>
              </div>
            </div>
            
            <div
              class="w3-margin-bottom"
              v-if="(
                compra.mostrar_detalhes && 
                compra.itens && 
                compra.itens.length > 0
              )">

              <div style="border-bottom: 2px dotted #a3a3a3; margin-top:5px;" class="w3-col"></div>
              <h6>
                &nbsp;
                <i class="fas fa-shopping-cart">
                </i>&nbsp;
                <strong style="color: #333333;"> Itens da compra</strong> 
              </h6>
              <div style="border-bottom: 2px dotted #a3a3a3;" class="w3-col"></div>
              <div style="margin-bottom:25px;" />
              
              <div class="col s12" v-if="compra.mostrar_detalhes">
                <div
                  class="card-item w3-container w3-white"
                  v-for="(item, index) in compra.itens"
                  :key="index"
                  style="padding: 0px;">

                  <div class="w3-col 12" >
                    <strong style="color:green;">R$ {{item.total_liquido}}</strong>
                    <label  style="font-weight: inherit; font-style: italic; margin-left: calc(100% - 140px);">Item {{index + 1}}</label>
                  </div>

                  <div class="w3-col s12">
                    <strong class="w3-text-theme">{{item.produto_id}} - {{item.nome_produto}} - {{item.unidade_compra}}</strong>
                  </div>

                  <div class="w3-col s12" v-if="item.preco != '0'">
                    <label>Preço unitário: </label>
                    <strong>R$ {{item.preco | retirarZeros}}</strong>
                  </div>

                  <div class="w3-col s12" v-if="item.quantidade != '0'">
                    <label>Quantidade</label>
                    <strong>{{item.quantidade}}</strong>
                  </div>

                  <div class="w3-col s12" v-if="item.valor_desconto != '0,0000'">
                    <label>Valor desconto</label>
                    <strong>R$ {{item.valor_desconto}}</strong>
                  </div>

                  <div class="w3-col s12" v-if="item.perc_desconto != '0,0000'">
                    <label>Desconto</label>
                    <strong>{{item.perc_desconto}}%</strong>
                  </div>

                  <div class="w3-col s12" v-if="item.valor_frete != '0'">
                    <label>Valor frete</label>
                    <strong>R$ {{item.valor_frete}}</strong>
                  </div>

                  <div class="w3-col s12" v-if="item.valor_ipi_outras_despesas != '0'">
                    <label>Outras despesas</label>
                    <strong>R$ {{item.valor_ipi_outras_despesas}}</strong>
                  </div>

                  <div class="w3-col s12" v-if="item.valor_ipi != '0'">
                    <label>Valor IPI</label>
                    <strong>R$ {{item.valor_ipi}}</strong>
                  </div>

                </div>
              </div>

            </div>
          </div>
        </div>
      </div>

      <paginacao
        @pagina="mudarPagina"
        :pagina-atual="pagina_atual"
        :itens-por-pagina="itens_por_pagina"
        :total-resultados="total_resultados" 
        :total-de-paginas="total_de_paginas"/>
    </div>

  </div>
</template>

<script>
  import formatarValorMixin from '@/mixins/formatarValorMixin.js'
  import Paginacao from '@/components/Paginacao'
  import toastr from 'toastr'
  import RCompraBuscarComprasBloqueadasDashboard from '@/components/Rest/RCompra/RCompraBuscarComprasBloqueadasDashboard.js'
  import RCompraLiberarCompra from '@/components/Rest/RCompra/RCompraLiberarCompra.js'
  import RCompraCancelarCompra from '@/components/Rest/RCompra/RCompraCancelarCompra.js'
  import RCompraBuscarCompraDetalhada from '@/components/Rest/RCompra/RCompraBuscarCompraDetalhada.js'
  import legenda from '@/components/Legendas'
  import Biblioteca from '@/components/Repositorio/Biblioteca';
  
  export default {
    name: 'ComprasBloqueadas',

    props: ['empresasIds'],

    components: {
      Paginacao,
      legenda
    },

    mixins:[formatarValorMixin],

    data() {
      const self = this;
      return {
        filtro: '',        
        processando: false,
        processando_itens: true,        
        compras_filtradas: [],
        compras_bloqueadas: [],
        

        pagina_atual: 0,
        itens_por_pagina: 10,
        total_resultados: 0,
        total_de_paginas: 0
      }
    },

    filters: {
      retirarZeros(preco) {
        return preco.slice(0, -5);
      }
    },
    
    mounted() {
      $('html,body').stop().animate(
        {scrollTop: 0}, 
        'slow', 
        'swing'
      );
    },

    methods: {
      mudarPagina(numeroDaPagina) {
        this.pagina_atual = numeroDaPagina;
      },

      buscarIndiceCompra(compra_id) {
        if ((!this.compras_filtradas) || (this.compras_filtradas.length == 0)) {
          return -1;
        }

        for (let i = 0; i < this.compras_filtradas.length; i++) {
          if (this.compras_filtradas[i].compra_id == compra_id) {
            return i;
          }
        }

        return -1;
      },

      async mostrarDetalhes(compra_id) {
        let indice = this.buscarIndiceCompra(compra_id);
        if (indice == -1) {
          return;
        }

        this.processando_itens = true;
        let mostrar_detalhes = !this.compras_filtradas[indice].mostrar_detalhes;
        this.compras_filtradas[indice].mostrar_detalhes = mostrar_detalhes;
        
        if (!mostrar_detalhes) {
          this.processando_itens = false;
          return;
        }

        if (this.compras_filtradas[indice].itens) {
          this.processando_itens = false;
          return;
        }

        try {
          let parametros = {
            compra_id: compra_id
          }

          let retorno = await RCompraBuscarCompraDetalhada.buscarCompraDetalhada(
            this.axios,
            parametros
          );

          if (retorno.houve_erro != 'N') {
            throw new Error(retorno.mensagem);
          }

          this.compras_filtradas[indice] = JSON.parse(JSON.stringify(retorno.dados));
          this.compras_filtradas[indice].mostrar_detalhes = mostrar_detalhes;
          
          this.compras_filtradas = JSON.parse(JSON.stringify(this.compras_filtradas));
          
          this.processando = false;
          this.processando_itens = false;
        }
        catch (error) {
          this.processando = false;
        }
      },

      filtrarPedidos() {
        this.compras_filtradas = [];
        this.mudarPagina(0);
      
        if(this.filtro == '') {
          this.compras_filtradas = this.compras_bloqueadas;
          return;
        }
        
        for (let i = 0; i < this.compras_bloqueadas.length; i++) {
          if (this.compras_bloqueadas[i].nome_fornecedor.toUpperCase().indexOf(this.filtro.toUpperCase()) > -1) {
            this.compras_filtradas.push(this.compras_bloqueadas[i]);
          }

          if (this.compras_bloqueadas[i].compra_id.replace('.', '').indexOf(this.filtro) > -1) {
            this.compras_filtradas.push(this.compras_bloqueadas[i]);
          }
        }
      },

      async buscarCompras() {      
        this.processando = true;
        this.compras_bloqueadas = {}; 
        this.compras_bloqueadas_filtradas = {};
        let empresas = {};
      
        try {
          let parametros = {
            empresas_ids: this.empresasIds
          }
          
          let retorno = await RCompraBuscarComprasBloqueadasDashboard.buscarComprasBloqueadasDashboard(
            this.axios, 
            parametros
          );

          if (retorno.houve_erro != 'N') {
            throw new Error(retorno.mensagem);
          }

          this.compras_bloqueadas = JSON.parse(JSON.stringify(retorno.dados.compras_bloqueadas));
          for(let i in this.compras_bloqueadas.itens ){
            this.compras_bloqueadas.itens[i].total_liquido =  Biblioteca.nPadraoReais(this.compras_bloqueadas.itens[i].total_liquido);
          }
          this.compras_filtradas = JSON.parse(JSON.stringify(this.compras_bloqueadas));
          this.processando = false;
        } 
        catch (error) {
          this.processando = false;
        }
      },

      liberarCompra(codigo_compra) {
        const self = this;

        swal({
          title: 'Confirmação de liberação de compras',
          className: 'modalLiberarCompra',
          buttons: ['Cancelar', 'Confirmar liberação'],
          showCloseButton: true,
          text: 'Observações das liberações',
          focusConfirm: false,
          content: {
            element: 'textarea',
            attributes: {
              rows: 3,
              class: 'w3-input w3-block w3-border',
            }
          }
        })
        .then(
          async (isConfirm, inputValue) => {
            let textarea = document.querySelector('.modalLiberarCompra .swal-content__textarea').value
            if (!isConfirm) {
              return false;
            }

            try {
              let parametros = {
                compra_id: codigo_compra,
                observacao: textarea
              }

              let retorno = await RCompraLiberarCompra.liberarCompra(this.axios, parametros);
              if (retorno.houve_erro != 'N') {
                throw new Error(retorno.mensagem);
              }

              toastr.success("Compra liberada com sucesso.");
              self.$emit('liberarRecusarCompra');
            }
            catch (error) {
              toastr.error(error.message);
            }
          }
        );
      },

      recusarCompra: function(codigo_compra) {
        const self = this;

        swal({
          title: 'Motivo de cancelamento da compra',
          className: 'modalLiberarCompra',
          buttons: ['Cancelar', 'Recusar'],
          showCloseButton: true,
          text: 'Motivo de cancelamento da compra',
          focusConfirm: false,
          content: {
            element: 'textarea',
            attributes: {
              rows: 3,
              class: 'w3-input w3-block w3-border',
            }
          }
        })
        .then(
          async (isConfirm) => {
            let textarea = document.querySelector('.modalLiberarCompra .swal-content__textarea').value

            if (!isConfirm) {
              return false;
            }
              
            if(textarea === '') {
              toastr.error('O motivo do cancelamento da compra não pode ser vazio');
              return false;
            }

            try {
              let parametros = {
                compra_id: codigo_compra,
                observacao: textarea
              }

              let retorno = await RCompraCancelarCompra.cancelarCompra(this.axios, parametros);
              console.log('retorno', retorno)
              
              if (retorno.houve_erro != 'N') {
                throw new Error(retorno.mensagem);
              }

              toastr.success("Compra recusada com sucesso.");
              self.$emit('liberarRecusarCompra');
            }
            catch (error) {
              toastr.error(error.message);
            }
          }
        );
      }
    },

    computed: {
      novasComprasBloqueadasFiltradas() {
        this.total_resultados = this.compras_filtradas.length;
        this.total_de_paginas =  Math.ceil(this.total_resultados / this.itens_por_pagina);

        if (this.pagina_atual >= this.total_de_paginas) { 
          this.pagina_atual = this.total_de_paginas;
        }

        let index = this.pagina_atual * this.itens_por_pagina;
        if (this.total_resultados > this.itens_por_pagina) {
          return this.compras_filtradas.slice(index, index + this.itens_por_pagina);
        } 
        else {
          return this.compras_filtradas;
        }
      }
    },

    created() {
      this.buscarCompras();
    }
  }
</script>

<style scoped>
  .card-item {
    background: rgb(235, 235, 235);
    border-radius: 10px;
    margin-bottom: 10px;
    padding: 5px !important;
    border: 2px solid #ccc;
    box-shadow: #6b6b6b 2px 2px 5px 2px;
  }
  
  .w3-modal-content {
    margin: 0 !important;
    transform: translateX(50%);
  }

  .divTabelaBloqueios {
    width: 100%;
    float: left;
    overflow: auto;
  }

  .btn-liberar, .btn-voltar-orcamento {
    width: auto !important
  }

  .btn-itens {
    width: 270px; 
    margin-top:5px; 
    float: right;
  }

  @media only screen and (max-width: 600px) {
    .btn-itens {
        width: 100%;
        float: none;
      }
  }
  
  .dados_mapa {
    margin-top: 20px;
  }

  .texto-responsivo {
    word-break: break-word;
    word-wrap: break-word;
    -webkit-hyphens: auto;
    -moz-hyphens: auto;
    hyphens: auto;
  }

  .w3-modal-content {
    margin: 0 !important;
    transform: translateX(50%);
  }

  .row-mapa-financeiro{
   padding: 0 
  }

  .divTabelaBloqueios {
    width: 100%;
    float: left;
  }

  .chip-vencimento {
    border-radius: 25px;
    cursor: pointer;
    font-size: .9em;
    padding: 10px 15px;
    text-decoration: underline;
  }

  .card-portador {
    border-left: 3px solid #9c1d1c;
    border-bottom-style: solid;
    border-bottom-width: 1px;
    border-bottom-color: #636363 ;
    padding: 5px 10px;
  }

  .card-portador .w3-text-theme {
    text-transform: uppercase;
  }

  @media(max-width: 992px) {
    .dados_mapa.w3-row-padding {
      padding: 0 !important
    }
    
    .box-contas {
      margin-bottom: 20px
    }

    .box-contas:last-child {
      margin-bottom: 0;
    }
  }

  @media(max-width: 500px) {
    .card-item .w3-row-padding {
      padding: 0
    }
  }

  .card-informacoes {
    margin-bottom: 10px;
    border-left-style: solid;
    border-left-color: #636363 !important;
    border-bottom-style: solid;
    border-bottom-width: 1px;
    float: left;
    padding: 7px;
    border-bottom-color: #636363 !important;
    background: white
  }

  .btn-liberar {
    width: auto !important;
  }

  .w3-right {
    float: none !important;
    padding-left: 10px;
  }

  .itens-mobile-info {
    float: right
  }

  .td-itens {
    white-space: nowrap;
    text-align: center
  }

  th {
    background: #d4d4d4;
    white-space: nowrap;
  }

  .itens-mobile {
    text-align: left
  }

  .w3-container {
    padding: 0
  }

  .conteudo-centralizado {
    padding: 20px;
    padding-top: 0px !important;
  }

  .itens {
    background: #d4d4d4;
    margin-bottom: 0 !important;
    padding-bottom: 0px;
  }

  @media(max-width: 600px) {
    .conteudo-centralizado {
      padding-top: 20px !important
    }
  }

  .fade-enter-active, .fade-leave-active {
    transition: opacity .3s;
  }

  .fade-enter, .fade-leave-to {
    opacity: 0;
  }
</style>


// WEBPACK FOOTER //
// src/components/Dashboard/ComprasBloqueadas.vue